import { Question } from './question';

export class Suitability {
  adequacy: Array<Question>;
  compatibility: Array<Question>;
  knowledge: Array<Question>;
  fillDate?: String;
  score?: number;
  profile?: string;
  track?: Array<any>;
  wantToNotFillSuitability?: boolean;
  wantToNotFillSuitabilityDate?: String;
  isSignedTerm?: boolean;
  dispensed: boolean;
  dispensedReason: string;
}
